import { ArrowUp } from "lucide-react";
import { scrollToId } from "./motion";

export default function Footer() {
    const toTop = () => {
        if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.4 });
        else window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <footer className="border-t border-cream/10 bg-ink px-6 py-10 text-cream md:px-12">
            <div className="mx-auto flex max-w-[1440px] flex-col items-start justify-between gap-6 md:flex-row md:items-center">
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-cream/50">
                    © {new Date().getFullYear()} In Skin — Clinical skin. Elevated you.
                </p>
                <div className="flex items-center gap-8">
                    <a
                        data-testid="footer-instagram-link"
                        href="https://instagram.com/inskinau"
                        target="_blank"
                        rel="noreferrer"
                        className="link-underline font-mono text-[10px] uppercase tracking-[0.25em] text-sand"
                    >
                        @inskinau
                    </a>
                    <button
                        data-testid="footer-philosophy-link"
                        onClick={() => scrollToId("philosophy")}
                        className="link-underline font-mono text-[10px] uppercase tracking-[0.25em] text-cream/60"
                    >
                        Philosophy
                    </button>
                    <button
                        data-testid="footer-back-to-top-button"
                        onClick={toTop}
                        aria-label="Back to top"
                        className="flex h-10 w-10 items-center justify-center rounded-full border border-cream/20 transition-all duration-300 hover:bg-cream hover:text-ink"
                    >
                        <ArrowUp size={15} strokeWidth={1.5} />
                    </button>
                </div>
            </div>
        </footer>
    );
}
